{
  "app": {
    "name": "VECOS Admin",
    "skipToContent": "Aller au contenu"
  },
  "nav": {
    "overview": "Vue d’ensemble",
    "people": "Personnes",
    "worlds": "Mondes",
    "assets": "Ressources",
    "avatars": "Avatars",
    "groups": "Groupes et permissions",
    "flags": "Fonctionnalités",
    "parameters": "Limites",
    "moderation": "Modération",
    "system": "Système",
    "audit": "Journal d’audit",
    "sectionPlatform": "Plateforme",
    "sectionContent": "Contenu",
    "sectionAccess": "Accès",
    "sectionOperations": "Exploitation",
    "openMenu": "Ouvrir le menu",
    "categories": "Catégories de mondes",
    "site": "Site vitrine",
    "legal": "Documents légaux",
    "analytics": "Statistiques",
    "releases": "Versions"
  },
  "auth": {
    "title": "VECOS Admin",
    "subtitle": "Connectez-vous pour administrer la plateforme.",
    "email": "E-mail",
    "password": "Mot de passe",
    "signIn": "Se connecter",
    "signingIn": "Connexion…",
    "signOut": "Se déconnecter",
    "notAdmin": "Ce compte ne peut pas utiliser le panneau d’administration.",
    "invalid": "Cet e-mail et ce mot de passe ne correspondent pas.",
    "rateLimited": "Trop de tentatives. Patientez un instant, puis réessayez.",
    "emailRequired": "Saisissez votre adresse e-mail.",
    "emailInvalid": "Cela ne ressemble pas à une adresse e-mail.",
    "passwordRequired": "Saisissez votre mot de passe.",
    "unavailable": "Le serveur ne répond pas. Réessayez dans un instant."
  },
  "theme": {
    "toggle": "Changer de thème",
    "light": "Clair",
    "dark": "Sombre",
    "system": "Suivre le système"
  },
  "language": {
    "label": "Langue",
    "switchTo": "Passer en {{language}}"
  },
  "common": {
    "cancel": "Annuler",
    "close": "Fermer",
    "save": "Enregistrer",
    "create": "Créer",
    "edit": "Modifier",
    "delete": "Supprimer",
    "remove": "Retirer",
    "retry": "Réessayer",
    "loadMore": "Afficher plus",
    "loading": "Chargement…",
    "all": "Tous",
    "none": "Aucun",
    "yes": "Oui",
    "no": "Non",
    "actions": "Actions",
    "copied": "Copié",
    "copyId": "Copier l’identifiant",
    "notSet": "—",
    "never": "Jamais",
    "unknown": "Inconnu",
    "showing_one": "{{count}} sur {{total}} affiché",
    "showing_other": "{{count}} sur {{total}} affichés",
    "showing_many": "{{count}} sur {{total}} affichés",
    "requiredField": "Ce champ est obligatoire.",
    "sortBy": "Trier par",
    "moreActions": "Plus d’actions",
    "add": "Ajouter",
    "openInNewTab": "Ouvrir dans un nouvel onglet",
    "reset": "Réinitialiser"
  },
  "state": {
    "emptyTitle": "Rien ici pour l’instant",
    "emptyFiltered": "Aucun résultat pour ces filtres",
    "emptyFilteredHint": "Élargissez la recherche ou retirez un filtre.",
    "errorTitle": "Une erreur est survenue",
    "errorHint": "Le serveur a refusé cette requête.",
    "offlineTitle": "Serveur injoignable",
    "offlineHint": "Vérifiez que le backend tourne, puis réessayez.",
    "forbiddenTitle": "Vous n’avez pas la permission",
    "forbiddenHint": "Il manque à ce compte la permission qu’exige cette page.",
    "notFoundTitle": "Introuvable",
    "notFoundHint": "Cette page n’existe pas, ou elle a été déplacée.",
    "goHome": "Retour à la vue d’ensemble"
  },
  "overview": {
    "title": "Vue d’ensemble",
    "subtitle": "La plateforme en un coup d’œil.",
    "people": "Personnes",
    "peopleTotal": "Comptes",
    "peopleNew": "Nouveaux cette semaine",
    "peopleDisabled": "Désactivés",
    "dau": "Actifs par jour",
    "wau": "Actifs par semaine",
    "mau": "Actifs par mois",
    "worlds": "Mondes",
    "worldsTotal": "Mondes",
    "worldsPublished": "Publiés",
    "worldsNew": "Nouveaux cette semaine",
    "rooms": "Salles",
    "liveInstances": "Salles ouvertes",
    "occupantsNow": "Personnes en salle",
    "visits24h": "Visites aujourd’hui",
    "medianSession": "Session médiane",
    "assets": "Ressources",
    "storage": "Stockage",
    "storageUsed": "Stocké",
    "social": "Social",
    "friendships": "Amitiés",
    "messages24h": "Messages aujourd’hui",
    "worldChat24h": "Chat de monde aujourd’hui",
    "moderationToday": "Modération aujourd’hui",
    "activeRestrictions": "Restrictions en cours",
    "trendChart": "Activité",
    "topWorlds": "Mondes les plus fréquentés",
    "topWorldsEmpty": "Aucun monde n’a encore été visité.",
    "storageByType": "Stockage par type",
    "needsAttention": "À surveiller",
    "attentionFailedJobs_one": "{{count}} ressource n’a pas pu être traitée",
    "attentionFailedJobs_other": "{{count}} ressources n’ont pas pu être traitées",
    "attentionFailedJobs_many": "{{count}} ressources n’ont pas pu être traitées",
    "attentionOrphaned_one": "{{count}} fichier orphelin occupe {{size}}",
    "attentionOrphaned_other": "{{count}} fichiers orphelins occupent {{size}}",
    "attentionOrphaned_many": "{{count}} fichiers orphelins occupent {{size}}",
    "attentionNoFeatured": "Aucun monde n’est à la une, la bannière d’accueil est donc vide",
    "attentionAllClear": "Rien à signaler."
  },
  "metric": {
    "signups": "Inscriptions",
    "logins": "Connexions",
    "visits": "Visites de salles",
    "worlds_created": "Mondes créés",
    "assets_uploaded": "Ressources envoyées",
    "messages": "Messages",
    "moderation_actions": "Actions de modération"
  },
  "range": {
    "label": "Période",
    "7d": "7 jours",
    "30d": "30 jours",
    "90d": "90 jours",
    "365d": "12 mois"
  },
  "users": {
    "title": "Personnes",
    "subtitle": "Tous les comptes de la plateforme.",
    "searchPlaceholder": "Rechercher par nom ou e-mail…",
    "status": "Statut",
    "statusAll": "Tous",
    "statusActive": "Actif",
    "statusDisabled": "Désactivé",
    "statusDeleted": "Supprimé",
    "group": "Groupe",
    "columnPerson": "Personne",
    "columnStatus": "Statut",
    "columnGroups": "Groupes",
    "columnWorlds": "Mondes",
    "columnStorage": "Stockage",
    "columnJoined": "Inscription",
    "columnLastSeen": "Vu pour la dernière fois",
    "badgeDisabled": "Désactivé",
    "badgeDeleted": "Supprimé",
    "badgeActive": "Actif",
    "empty": "Aucun compte pour l’instant.",
    "detailTitle": "Compte",
    "tabOverview": "Vue d’ensemble",
    "tabSessions": "Appareils",
    "tabGroups": "Groupes",
    "tabLimits": "Limites",
    "tabWorlds": "Mondes",
    "tabModeration": "Modération",
    "tabActivity": "Historique de connexion",
    "identities": "Méthodes de connexion",
    "identityLinked": "Liée le {{date}}",
    "sessions": "Appareils connectés",
    "sessionsEmpty": "Aucune session en cours.",
    "sessionCurrent": "Cet appareil",
    "revokeSession": "Déconnecter cet appareil",
    "revokeAll": "Déconnecter partout",
    "revokeAllConfirm": "Déconnecter tous les appareils ?",
    "revokeAllBody": "{{name}} devra se reconnecter sur chaque appareil. Rien d’autre ne change.",
    "disable": "Désactiver le compte",
    "enable": "Réactiver le compte",
    "disableConfirm": "Désactiver ce compte ?",
    "disableBody": "{{name}} sera déconnecté partout et ne pourra plus se connecter tant que vous n’aurez pas réactivé le compte. Ses mondes et ses ressources sont conservés.",
    "disableReason": "Motif (consigné dans le journal d’audit)",
    "enableConfirm": "Réactiver ce compte ?",
    "enableBody": "{{name}} pourra de nouveau se connecter.",
    "deleteAccount": "Supprimer le compte",
    "deleteConfirm": "Supprimer ce compte ?",
    "deleteBody": "{{name}} sera déconnecté et retiré de la plateforme. Il s’agit d’une suppression réversible — les données restent et un ingénieur peut les restaurer — mais la personne perd l’accès immédiatement.",
    "cannotDisableSelf": "Vous ne pouvez pas désactiver votre propre compte.",
    "cannotDeleteSelf": "Vous ne pouvez pas supprimer votre propre compte.",
    "addToGroup": "Ajouter à un groupe",
    "removeFromGroup": "Retirer de {{group}}",
    "removeFromGroupConfirm": "Retirer de {{group}} ?",
    "removeFromGroupBody": "{{name}} perd toutes les permissions que porte ce groupe.",
    "noGroups": "Dans aucun groupe.",
    "recentLogins": "Connexions récentes",
    "loginSuccess": "Connecté",
    "loginFailed": "Échec",
    "noLogins": "Aucune connexion enregistrée.",
    "moderationAgainst": "Actions prises contre ce compte",
    "noModeration": "Rien n’a été enregistré contre ce compte.",
    "ownedWorlds": "Mondes possédés",
    "noWorlds": "Ce compte ne possède aucun monde.",
    "storageBreakdown": "Stockage utilisé",
    "disabled": "Compte désactivé",
    "enabled": "Compte réactivé",
    "deleted": "Compte supprimé",
    "sessionRevoked": "Appareil déconnecté",
    "allSessionsRevoked": "Déconnecté partout",
    "groupAdded": "Ajouté au groupe",
    "groupRemoved": "Retiré du groupe",
    "addToGroupAction": "Ajouter au groupe",
    "tabAnalytics": "Analyses"
  },
  "worlds": {
    "title": "Mondes",
    "subtitle": "Tous les mondes, quels que soient leur statut et leur confidentialité.",
    "searchPlaceholder": "Rechercher un monde…",
    "status": "Statut",
    "privacy": "Confidentialité",
    "category": "Catégorie",
    "featuredOnly": "À la une uniquement",
    "columnWorld": "Monde",
    "columnOwner": "Propriétaire",
    "columnStatus": "Statut",
    "columnPrivacy": "Confidentialité",
    "columnActive": "Maintenant",
    "columnVisits": "Visites",
    "columnRating": "Note",
    "columnCreated": "Créé le",
    "statusDRAFT": "Brouillon",
    "statusPUBLISHED": "Publié",
    "statusARCHIVED": "Archivé",
    "privacyPUBLIC": "Public",
    "privacyPRIVATE": "Privé",
    "privacyCODE": "Code",
    "badgeFeatured": "À la une",
    "badgeDeleted": "Supprimé",
    "empty": "Aucun monde pour l’instant.",
    "detailTitle": "Monde",
    "tabOverview": "Vue d’ensemble",
    "tabInstances": "Instances",
    "tabVisits": "Visites",
    "tabGroups": "Groupes",
    "tabModeration": "Modération",
    "feature": "Mettre à la une sur l’accueil",
    "unfeature": "Retirer de l’accueil",
    "featured": "À la une",
    "featuredHint": "Les mondes à la une apparaissent dans la bannière de l’accueil, dans l’ordre ci-dessous.",
    "featuredEmpty": "Aucun monde n’est à la une. La bannière d’accueil est vide.",
    "featuredOrder": "Ordre dans la bannière",
    "featuredReorder": "Glissez pour réordonner la bannière",
    "featureSaved": "La bannière d’accueil a été mise à jour.",
    "sceneObjects": "Objets placés",
    "instances": "Instances",
    "uniqueVisitors": "Visiteurs uniques",
    "ratingBreakdown": "Notes",
    "noRatings": "Pas encore noté.",
    "noInstances": "Aucune instance.",
    "noVisits": "Personne n’a encore visité ce monde.",
    "deleteWorld": "Supprimer le monde",
    "deleteConfirm": "Supprimer ce monde ?",
    "deleteBody": "{{title}} disparaît de la découverte et personne ne peut plus y entrer. La suppression est réversible.",
    "restore": "Restaurer le monde",
    "restoreConfirm": "Restaurer ce monde ?",
    "restoreBody": "{{title}} redevient visible, à son statut précédent.",
    "restored": "Monde restauré",
    "deleted": "Monde supprimé",
    "updated": "Monde mis à jour",
    "editTitle": "Modifier le monde",
    "fieldTitle": "Titre",
    "fieldDescription": "Description",
    "fieldCategory": "Catégorie",
    "fieldPrivacy": "Confidentialité",
    "fieldStatus": "Statut",
    "privacyINVITE": "Sur invitation"
  },
  "assets": {
    "title": "Ressources",
    "subtitle": "Tous les fichiers envoyés sur la plateforme.",
    "searchPlaceholder": "Rechercher une ressource…",
    "type": "Type",
    "visibility": "Visibilité",
    "columnAsset": "Ressource",
    "columnType": "Type",
    "columnOwner": "Propriétaire",
    "columnVisibility": "Visibilité",
    "columnSize": "Taille",
    "columnStatus": "Statut",
    "columnUploaded": "Envoyée le",
    "typeIMAGE": "Image",
    "typeVIDEO": "Vidéo",
    "typeDOCUMENT": "Document",
    "typeAUDIO": "Audio",
    "typeSKYBOX": "Skybox",
    "visibilityPRIVATE": "Privée",
    "visibilityPUBLIC": "Publique",
    "visibilityPAID": "Payante",
    "platformOwned": "Plateforme",
    "empty": "Aucune ressource pour l’instant.",
    "detailTitle": "Ressource",
    "reprocess": "Relancer le traitement",
    "reprocessQueued": "Mise en file. Le fichier est traité à nouveau.",
    "uploadTitle": "Envoyer dans la bibliothèque de la plateforme",
    "uploadHint": "Les ressources de la plateforme n’appartiennent à personne et sont accessibles à tous.",
    "uploadType": "Type de ressource",
    "uploadTypePrompt": "Choisissez un type…",
    "renderingPreview": "Génération de l’aperçu…",
    "uploadName": "Nom",
    "uploadCategory": "Dossier",
    "uploadDrop": "Déposez un fichier ici, ou choisissez-en un",
    "uploading": "Envoi…",
    "uploaded": "Envoyée",
    "deleteConfirm": "Supprimer cette ressource ?",
    "deleteBody": "{{name}} est retirée de la bibliothèque. Tout monde qui l’utilise la perd.",
    "deleted": "Ressource supprimée",
    "updated": "Ressource mise à jour",
    "jobsTitle": "File de traitement",
    "jobsSubtitle": "Les envois en attente de conversion, et ceux qui ont échoué.",
    "jobStatus": "Statut",
    "jobAttempts": "Tentatives",
    "jobError": "Erreur",
    "retryJob": "Réessayer",
    "retried": "Remise en file",
    "reconcile": "Réparer les envois bloqués",
    "reconcileConfirm": "Réparer les envois bloqués ?",
    "reconcileBody": "Toute ressource sans tâche de traitement sera mise en file. L’opération est sans risque, à tout moment.",
    "reconciled_one": "{{count}} envoi bloqué remis en file.",
    "reconciled_other": "{{count}} envois bloqués remis en file.",
    "reconciled_many": "{{count}} envois bloqués remis en file.",
    "reconciledNone": "Rien n’était bloqué.",
    "noJobsPending": "La file est vide.",
    "typeMODEL_3D": "Modèle 3D",
    "typeIMAGE_360": "Image 360",
    "typeVIDEO_360": "Vidéo 360",
    "clickToPreview": "Cliquez pour prévisualiser",
    "previewFailed": "Ce fichier n’a pas pu être affiché. Il est peut-être encore en traitement, ou la copie stockée est endommagée.",
    "noPreview": "Aucun aperçu n’est disponible pour ce type de fichier.",
    "pdfNoInlineViewer": "Ce navigateur n’affiche pas les PDF en ligne. Ouvrez-le plutôt dans un nouvel onglet.",
    "loadingViewer": "Chargement de la visionneuse 3D…",
    "downloadOriginal": "Télécharger",
    "originalFilename": "Fichier d’origine",
    "contentType": "Format",
    "usages": "Utilisée comme",
    "noThumbnail": "Aucune miniature",
    "loadingModel": "Chargement du modèle…",
    "background": "Fond",
    "backgroundNormal": "Normal",
    "backgroundLight": "Clair",
    "backgroundDark": "Sombre",
    "regenerateThumbnail": "Régénérer la miniature",
    "thumbnailSaved": "Aperçu enregistré.",
    "modelVersion": "Quelle version",
    "versionOptimised": "Optimisée",
    "versionOriginal": "Originale",
    "wireframe": "Fil de fer",
    "autoRotate": "Rotation",
    "vertices": "Sommets",
    "triangles": "Triangles",
    "meshes": "Maillages",
    "materials": "Matériaux",
    "dimensions": "Dimensions (m)",
    "animations": "Animations",
    "lodLevels": "Niveaux de détail",
    "rigged": "Squelette"
  },
  "avatars": {
    "title": "Avatars",
    "subtitle": "Le catalogue d’avatars dans lequel chacun choisit.",
    "searchPlaceholder": "Rechercher un avatar…",
    "category": "Catégorie",
    "columnAvatar": "Avatar",
    "columnCategory": "Catégorie",
    "columnOrder": "Ordre",
    "columnStatus": "Statut",
    "badgeActive": "Actif",
    "badgeInactive": "Masqué",
    "badgePremium": "Premium",
    "empty": "Le catalogue est vide. Ajoutez un avatar pour commencer.",
    "add": "Ajouter un avatar",
    "addTitle": "Ajouter un avatar au catalogue",
    "editTitle": "Modifier l’avatar",
    "fieldName": "Nom",
    "fieldCategory": "Catégorie",
    "fieldOrder": "Ordre de tri",
    "fieldActive": "Visible dans le catalogue",
    "fieldPremium": "Premium",
    "fieldModel": "Modèle (.glb)",
    "fieldThumbnail": "Miniature",
    "modelHint": "Un fichier GLB. Il est validé et optimisé exactement comme l’envoi d’un joueur.",
    "thumbnailHint": "Facultatif. Une image carrée donne le meilleur résultat.",
    "created": "Avatar ajouté",
    "updated": "Avatar mis à jour",
    "deleted": "Avatar retiré",
    "deleteConfirm": "Retirer cet avatar ?",
    "deleteBody": "{{name}} disparaît du catalogue. Si quelqu’un le porte, le serveur refusera — masquez-le plutôt, depuis le menu de la ligne.",
    "categories": "Catégories",
    "categoriesTitle": "Catégories d’avatars",
    "addCategory": "Ajouter une catégorie",
    "categoryKey": "Clé",
    "categoryName": "Nom",
    "categoryDeleteConfirm": "Supprimer cette catégorie ?",
    "categoryDeleteBody": "{{name}} est supprimée. Les avatars qu’elle contient deviennent sans catégorie.",
    "categoryNotEmpty": "{{name}} contient encore {{count}} avatars. Déplacez-les d’abord.",
    "categoryCreated": "Catégorie ajoutée",
    "categoryDeleted": "Catégorie supprimée",
    "columnDefault": "Par défaut",
    "badgeDefault": "Par défaut",
    "hiddenHint": "Les avatars masqués restent à ceux qui les portent déjà ; personne de nouveau ne peut les choisir.",
    "deleteRefused": "Cet avatar n’a pas pu être retiré",
    "takeThumbnail": "Prendre une miniature",
    "focusFace": "Cadrer le visage",
    "noHeadBone": "Aucun os de tête dans ce squelette, la vue a donc été laissée telle quelle.",
    "picture": "Image de la galerie",
    "pictureHint": "Affichée dans le sélecteur d’avatars. Une image carrée donne le meilleur résultat.",
    "uploadPicture": "Envoyer une image",
    "showModel": "Afficher le modèle",
    "hideModel": "Masquer le modèle",
    "noModel": "Cet avatar n’a aucun modèle stocké, il n’y a donc rien à afficher.",
    "capturedPreview": "Capturée depuis le modèle. Rien n’est enregistré tant que vous ne l’acceptez pas.",
    "useThisThumbnail": "Utiliser cette image",
    "thumbnailUpdated": "Image de la galerie mise à jour",
    "noPicture": "Aucune image"
  },
  "categories": {
    "title": "Catégories de mondes",
    "subtitle": "Les filtres par lesquels on parcourt les mondes.",
    "add": "Ajouter une catégorie",
    "key": "Clé",
    "name": "Nom",
    "active": "Visible",
    "worlds": "Mondes",
    "empty": "Aucune catégorie pour l’instant.",
    "created": "Catégorie ajoutée",
    "updated": "Catégorie mise à jour",
    "deleted": "Catégorie supprimée",
    "deleteConfirm": "Supprimer cette catégorie ?",
    "deleteBody": "{{name}} disparaît des filtres.",
    "notEmpty": "{{name}} contient encore {{count}} mondes. Déplacez-les d’abord.",
    "keyHint": "En minuscules, sans espaces. Elle ne pourra plus être modifiée."
  },
  "groups": {
    "title": "Groupes et permissions",
    "subtitle": "Ce que chaque groupe de personnes a le droit de faire.",
    "platformGroups": "Groupes de la plateforme",
    "add": "Créer un groupe",
    "createTitle": "Créer un groupe",
    "editTitle": "Modifier le groupe",
    "fieldName": "Nom",
    "fieldDescription": "Description",
    "fieldColor": "Couleur",
    "badgeSystem": "Intégré",
    "systemHint": "Les groupes intégrés ne peuvent être ni renommés ni supprimés, mais ce qu’ils portent est modifiable.",
    "empty": "Aucun groupe pour l’instant.",
    "permissions": "Permissions",
    "permissionsHeld_one": "{{count}} sur {{total}}",
    "permissionsHeld_other": "{{count}} sur {{total}}",
    "permissionsHeld_many": "{{count}} sur {{total}}",
    "planGated": "Formule",
    "members": "Membres",
    "addMember": "Ajouter quelqu’un",
    "pickerNoMatches": "Aucun compte ne correspond.",
    "alreadyMember": "Déjà membre",
    "addMemberPlaceholder": "Rechercher par nom ou e-mail…",
    "removeMember": "Retirer",
    "removeMemberConfirm": "Retirer {{name}} de {{group}} ?",
    "removeMemberBody": "Cette personne perd toutes les permissions que porte ce groupe.",
    "noMembers": "Personne n’est dans ce groupe.",
    "created": "Groupe créé",
    "updated": "Groupe mis à jour",
    "deleted": "Groupe supprimé",
    "memberAdded": "Ajouté au groupe",
    "memberRemoved": "Retiré du groupe",
    "deleteConfirm": "Supprimer ce groupe ?",
    "deleteBody": "{{name}} est supprimé et ses {{count}} membres perdent toutes les permissions qu’il portait.",
    "memberNotFound": "Aucun compte avec l’adresse {{email}}.",
    "impliedByWildcard": "Couverte par le joker que détient ce groupe"
  },
  "flags": {
    "title": "Fonctionnalités",
    "subtitle": "Activez et désactivez des parties du produit, pour tous ou pour quelques-uns.",
    "columnState": "État",
    "on": "Activée",
    "off": "Désactivée",
    "badgeSystem": "Obligatoire",
    "systemHint": "La plateforme dépend de cette fonctionnalité ; elle ne peut pas être désactivée.",
    "categoryOn": "Tout est activé dans {{name}}",
    "categoryOff": "Tout est désactivé dans {{name}}",
    "overrides": "Exceptions",
    "overridesHint": "Une exception l’emporte sur l’interrupteur ci-dessus pour un groupe ou une personne — c’est à cela que ressemble un déploiement progressif, vu de l’intérieur.",
    "addOverride": "Ajouter une exception",
    "overrideForGroup": "Pour un groupe",
    "overrideForUser": "Pour une personne",
    "overrideEnabled": "Activée pour eux",
    "overrideDisabled": "Désactivée pour eux",
    "removeOverride": "Retirer",
    "noOverrides": "Aucune exception. Tout le monde suit l’interrupteur.",
    "empty": "Aucune fonctionnalité.",
    "updated": "Fonctionnalité mise à jour",
    "overrideAdded": "Exception ajoutée",
    "overrideRemoved": "Exception retirée",
    "toggleConfirm": "Désactiver {{name}} ?",
    "toggleBody": "Tout le monde perd cette fonctionnalité immédiatement, y compris les personnes déjà en salle.",
    "search": "Rechercher une fonctionnalité…",
    "turnAllOff": "Tout désactiver",
    "turnAllOn": "Tout activer"
  },
  "parameters": {
    "title": "Limites",
    "subtitle": "Ce à quoi chaque formule et chaque compte a droit.",
    "columnLimit": "Limite",
    "columnDefault": "Par défaut",
    "columnGroups": "Par groupe",
    "unlimited": "Illimité",
    "notSet": "Par défaut",
    "setForGroup": "Définir pour un groupe",
    "clearForGroup": "Utiliser la valeur par défaut",
    "empty": "Aucune limite définie.",
    "updated": "Limite mise à jour",
    "cleared": "Limite effacée",
    "valueLabel": "Valeur",
    "valueHint": "Laissez vide pour revenir à la valeur par défaut.",
    "editFor": "{{limit}} pour {{group}}",
    "accountOverride": "Définir pour ce compte uniquement",
    "accountOverrideHint": "L’emporte sur ce que lui donnent ses groupes.",
    "sourceAccount": "Définie sur le compte",
    "sourceRole": "Depuis {{name}}",
    "sourceDefault": "Par défaut",
    "emptyHint": "Les limites sont initialisées depuis le catalogue du code. Si cette page est vide, la base n’a pas été initialisée — lancez le db:seed du backend.",
    "tableHint": "Chaque cellule est modifiable. Une limite laissée sur « Par défaut » suit la valeur par défaut de la plateforme ; en définir une sur un groupe l’emporte pour tous ses membres.",
    "valueInUnit": "Valeur ({{unit}})"
  },
  "moderation": {
    "title": "Modération",
    "subtitle": "Ce qui a été fait dans l’ensemble des mondes.",
    "tabActions": "Historique",
    "tabRestrictions": "Restrictions en cours",
    "type": "Action",
    "columnWhen": "Quand",
    "columnAction": "Action",
    "columnPerson": "Personne",
    "columnWorld": "Monde",
    "columnModerator": "Modérateur",
    "columnReason": "Motif",
    "columnExpires": "Jusqu’au",
    "permanent": "Permanente",
    "empty": "Rien n’a été enregistré.",
    "emptyRestrictions": "Aucune restriction n’est en vigueur nulle part.",
    "lift": "Lever",
    "liftConfirm": "Lever cette restriction ?",
    "liftBody": "{{name}} n’est plus {{restriction}} dans {{world}}.",
    "lifted": "Restriction levée",
    "typeMUTE": "Micro coupé",
    "typeUNMUTE": "Micro rétabli",
    "typeCHAT_MUTE": "Chat coupé",
    "typeCHAT_UNMUTE": "Chat rétabli",
    "typeKICK": "Expulsé",
    "typeBAN": "Banni",
    "typeUNBAN": "Débanni",
    "typeFREEZE": "Immobilisé",
    "typeUNFREEZE": "Libéré",
    "typeTELEPORT": "Téléporté",
    "typeVOICE_SCOPE": "Voix déplacée",
    "typeMUTE_ALL": "Tout le monde coupé",
    "typeUNMUTE_ALL": "Tout le monde rétabli",
    "everybody": "Tout le monde dans la salle",
    "platformWide": "Toute la plateforme"
  },
  "system": {
    "title": "Système",
    "subtitle": "L’état de marche de chaque brique.",
    "database": "Base de données",
    "redis": "Redis",
    "worker": "Worker",
    "queue": "File d’attente",
    "healthy": "Opérationnel",
    "degraded": "Dégradé",
    "down": "Hors service",
    "latency": "{{ms}} ms",
    "lastSeen": "Vu {{when}}",
    "queuePending": "En attente",
    "queueProcessing": "En cours",
    "queueFailed": "En échec",
    "version": "Version",
    "nodeVersion": "Node",
    "uptime": "Temps d’activité",
    "environment": "Environnement",
    "notReporting": "Ne rapporte rien",
    "noHeartbeatConfigured": "Aucun battement de cœur configuré (WORKER_HEARTBEAT_PATH) ; son état est donc inconnu plutôt que mauvais.",
    "serving": "Traite {{queues}}"
  },
  "audit": {
    "title": "Journal d’audit",
    "subtitle": "Chaque modification faite depuis ce panneau.",
    "columnWhen": "Quand",
    "columnWho": "Qui",
    "columnWhat": "Quoi",
    "columnResource": "Sur",
    "empty": "Rien n’a encore été modifié.",
    "from": "Du",
    "to": "Au"
  },
  "a11y": {
    "mainNavigation": "Navigation principale",
    "chartDescription": "{{metric}} entre {{from}} et {{to}}"
  },
  "site": {
    "title": "Site vitrine",
    "description": "Ce que le site public affiche, et dans quel ordre.",
    "sectionsTitle": "Sections de la page d’accueil",
    "sectionsDescription": "Désactivez une section pour la masquer aux visiteurs, ou déplacez-la pour changer son emplacement. Le site possède la liste ; vous décidez de ce qu’elle montre.",
    "sectionsSaved": "Disposition enregistrée",
    "sectionsSaveFailed": "Impossible d’enregistrer la disposition",
    "unsavedHint": "Ces modifications ne sont pas en ligne tant que vous n’enregistrez pas.",
    "visible": "Visible",
    "moveUp": "Monter {{name}}",
    "moveDown": "Descendre {{name}}",
    "sections": {
      "worlds": "Mondes en ligne",
      "make": "Scripts par blocs",
      "save": "La règle d’enregistrement",
      "platforms": "Où ça tourne",
      "sponsors": "Sponsors",
      "pricing": "Tarifs",
      "cta": "Appel à l’action final"
    },
    "sponsorsTitle": "Sponsors",
    "sponsorsDescription": "Les logos du bandeau de la page d’accueil. Les sponsors masqués gardent leur place dans l’ordre.",
    "addSponsor": "Ajouter un sponsor",
    "editSponsor": "Modifier le sponsor",
    "sponsorName": "Nom",
    "sponsorLink": "Lien",
    "sponsorLinkInvalid": "Doit commencer par http:// ou https://",
    "sponsorCreated": "Sponsor ajouté",
    "sponsorDeleted": "Sponsor retiré",
    "sponsorSaveFailed": "Impossible d’enregistrer le sponsor",
    "sponsorDeleteFailed": "Impossible de retirer le sponsor",
    "deleteSponsorTitle": "Retirer ce sponsor ?",
    "deleteSponsorBody": "{{name}} n’apparaîtra plus sur le site. C’est irréversible.",
    "noSponsors": "Aucun sponsor pour l’instant",
    "noSponsorsHint": "Le site affiche des marques provisoires tant que vous n’en ajoutez pas de vraies.",
    "noLogo": "Aucun logo",
    "logoUploadHint": "Enregistrez d’abord le sponsor, puis cliquez sur son carré dans la liste pour envoyer un logo.",
    "logoUploaded": "Logo mis à jour",
    "logoFailed": "Impossible de mettre à jour le logo",
    "replaceLogo": "Envoyer un logo pour {{name}}",
    "removeLogo": "Retirer le logo"
  },
  "legal": {
    "title": "Documents légaux",
    "description": "La politique de confidentialité et les conditions d'utilisation. Publier une version peut arrêter tous les utilisateurs jusqu'à ce qu'ils l'aient relue.",
    "termsOfService": "Conditions d'utilisation",
    "privacyPolicy": "Politique de confidentialité",
    "unknownDocument": "Le serveur connaît un document que ce panneau ne sait pas afficher.",
    "live": "En vigueur",
    "scheduled": "Programmée",
    "nothingPublished": "Rien de publié",
    "nothingPublishedHint": "Rédigez le document ci-dessous et publiez-le. D'ici là, il n'y a rien à accepter.",
    "versionNumber": "Version {{version}}",
    "editorTitle": "Le document",
    "editorDescription": "Markdown. L'aperçu à côté est le document tel qu'il s'affiche — le même texte que le site et l'application.",
    "documentTitle": "Titre",
    "bodyLabel": "Corps (Markdown)",
    "preview": "Aperçu",
    "saveDraft": "Enregistrer le brouillon",
    "draftSaved": "Brouillon enregistré. Personne ne le voit avant publication.",
    "draftSaveFailed": "Le brouillon n'a pas pu être enregistré.",
    "unsaved": "Modifications non enregistrées",
    "sourceDraft": "Brouillon",
    "sourcePublished": "Texte en vigueur",
    "sourceEmpty": "Vide",
    "publish": "Publier",
    "publishTitle": "Publier la version {{version}}",
    "publishDescription": "Ceci écrit une version permanente. Elle ne pourra plus être modifiée — une correction est une autre version.",
    "publishConfirm": "Publier",
    "published": "Publié. Personne n'a été interrompu.",
    "publishedAndAsking": "Publié. Tout le monde devra l'accepter de nouveau.",
    "publishFailed": "La version n'a pas pu être publiée.",
    "requiresReacceptance": "Changement important — redemander à tout le monde",
    "requiresReacceptanceOn": "Chaque utilisateur sera arrêté à sa prochaine connexion et devra lire et accepter cette version avant de continuer.",
    "requiresReacceptanceOff": "Personne n'est interrompu. À utiliser pour une faute de frappe, un lien cassé, ou tout ce qui ne change pas ce qui a été accepté.",
    "effectiveAt": "En vigueur à partir du",
    "effectiveAtHint": "Laissez vide pour publier maintenant. Une date future stocke la version sans la servir à personne jusque-là.",
    "englishFirst": "L'anglais doit être publié en premier. C'est la version de repli de toutes les autres langues.",
    "historyTitle": "Toutes les versions",
    "historyDescription": "{{count}} publiées. Rien n'est jamais modifié ni supprimé ici — c'est le registre de ce que les gens ont accepté.",
    "historyEmpty": "Aucune version",
    "historyEmptyDescription": "La première publication crée la version 1.",
    "reasked": "Redemandé à tous",
    "quietChange": "Changement discret",
    "unknownPublisher": "Inconnu",
    "column": {
      "version": "Version",
      "status": "État",
      "effective": "En vigueur à partir du",
      "publishedBy": "Publié par",
      "locales": "Langues"
    },
    "language": "Langue",
    "languagePublished": "publié",
    "languageDrafted": "brouillon",
    "languageMissing": "non rédigé"
  },
  "analytics": {
    "title": "Statistiques",
    "description": "Les vues détaillées. Le tableau de bord donne le résumé ; ici se trouvent les réponses aux questions qu'il soulève.",
    "range": "Période",
    "tab": {
      "worlds": "Mondes",
      "content": "Contenu",
      "operations": "Opérations",
      "growth": "Croissance",
      "users": "Utilisateurs",
      "acquisition": "Acquisition"
    },
    "worlds": {
      "title": "Classement des mondes",
      "description": "Tous les mondes, quels que soient leur statut et leur visibilité. Les mondes supprimés sont exclus.",
      "rankBy": "Classer par",
      "rank": {
        "visits": "Visites",
        "rating": "Note",
        "active": "Personnes présentes"
      },
      "world": "Monde",
      "owner": "Propriétaire",
      "visits": "Visites",
      "visitors": "Personnes",
      "rating": "Note",
      "ratingValue": "{{value}} ({{count}})",
      "unrated": "Non noté",
      "activeNow": "Présents",
      "featured": "Mis en avant",
      "emptyTitle": "Aucun monde",
      "emptyDescription": "Les mondes apparaissent ici dès la création du premier."
    },
    "content": {
      "totalStored": "Stocké",
      "orphaned": "Orphelins",
      "byOwner": "Comptes les plus volumineux",
      "byOwnerDescription": "Les vingt qui stockent le plus, en octets. Un total indique qu'il se passe quelque chose ; ceci indique à qui parler.",
      "ownerFigure": "{{size}} · {{count}}",
      "emptyTitle": "Rien de stocké",
      "emptyDescription": "Les comptes apparaissent ici dès le premier envoi.",
      "orphanedCount_one": "{{count}} objet",
      "orphanedCount_many": "{{count}} objets",
      "orphanedCount_other": "{{count}} objets"
    },
    "operations": {
      "actions": "Actions de modération",
      "kinds": "Types d'action",
      "byType": "Actions par type",
      "byTypeDescription": "C'est la répartition qui compte, pas le total : cinquante mises en sourdine et cinquante bannissements font le même nombre et deux semaines très différentes.",
      "emptyTitle": "Aucune modération sur cette période",
      "emptyDescription": "Rien n'a été modéré sur la période choisie. Essayez une période plus large."
    },
    "growth": {
      "dau": "Actifs aujourd'hui",
      "wau": "Actifs cette semaine",
      "mau": "Actifs ce mois",
      "stickiness": "Fidélité",
      "stickinessHint": "Actifs par jour ÷ actifs par mois",
      "funnel": "De l'inscription au retour",
      "funnelDescription": "Là où les nouveaux comptes s'arrêtent. Un total dit que la plateforme grandit ; ceci dit à quelle étape on perd des gens, ce sur quoi on peut agir.",
      "step": {
        "signedUp": "Inscrits",
        "signedIn": "Connectés",
        "enteredAWorld": "Entrés dans un monde",
        "returned": "Revenus"
      },
      "peak": "Moment le plus fréquenté : {{users}} en même temps, {{when}}.",
      "verified": "E-mail vérifié",
      "verifiedHint": "Pas une étape — la connexion ne l'exige pas"
    },
    "users": {
      "signIns": "Connexions",
      "accounts": "Comptes",
      "perAccount": "Connexions par compte",
      "medianSession": "Temps habituel dans un monde",
      "composition": "Qui ils sont",
      "compositionDescription": "Les chiffres sont des événements, pas des personnes — un décompte par valeur sur plusieurs jours ne peut pas être déduit d'un cumul quotidien sans compter quelqu'un deux fois. Le pic quotidien à côté est une borne inférieure.",
      "breakBy": "Répartir par",
      "dimension": {
        "country": "Pays",
        "platform": "Plateforme",
        "deviceClass": "Appareil",
        "locale": "Langue"
      },
      "rowFigure": "{{events}} événements · pic {{peak}}/jour",
      "clipped": "{{shown}} sur {{total}} affichés",
      "emptyTitle": "Rien d'enregistré",
      "emptyDescription": "Les valeurs apparaissent dès que le client a envoyé des événements pour cette période."
    },
    "acquisition": {
      "signups": "Inscriptions",
      "activated": "Activés",
      "activatedHint": "Sont entrés dans un monde au moins une fois",
      "retained": "Conservés une semaine",
      "retainedHint": "Vus 7 jours ou plus après l'inscription",
      "measured": "Attribués",
      "measuredHint": "Part des inscriptions dont la source est connue",
      "bySource": "D'où ils viennent",
      "bySourceDescription": "Inscriptions regroupées par l'attribution enregistrée à la création du compte. Les comptes sans attribution sont listés à part plutôt que rattachés à une source que personne ne revendique.",
      "methodOnly": "Ce déploiement n'enregistre aucune attribution : tous les comptes ci-dessous sont sans attribution et aucune source ne peut être comparée à une autre.",
      "unattributed": "Sans attribution",
      "emptyTitle": "Aucune inscription sur cette période",
      "emptyDescription": "Élargissez la plage, ou revenez quand de nouveaux comptes existeront.",
      "activatedRate": "{{percent}} % activés ({{count}})",
      "keptRate": "{{percent}} % conservés ({{count}})",
      "byMethod": "Comment ils se sont inscrits",
      "byMethodDescription": "Les mêmes comptes, répartis selon la porte qu'ils ont empruntée plutôt que selon l'endroit où ils en ont entendu parler.",
      "method": {
        "password": "E-mail et mot de passe",
        "google": "Connexion Google"
      },
      "methodFigure": "{{signups}} · {{activated}} % activés · {{retained}} % conservés"
    },
    "user": {
      "visits": "Visites de mondes",
      "visitsHint": "dans {{worlds}} mondes",
      "timeInWorlds": "Temps dans les mondes",
      "signIns": "Connexions",
      "lastActive": "Dernière activité",
      "whatTheyMade": "Ce qu'ils ont créé",
      "worldsCreated": "Mondes créés",
      "worldsCreatedValue": "{{created}} ({{published}} publiés)",
      "assetsUploaded": "Ressources envoyées",
      "storageUsed": "Stockage utilisé",
      "quizzesAuthored": "Quiz créés",
      "scriptsAuthored": "Scripts créés",
      "howTheyBehave": "Comment ils se comportent",
      "friends": "Amis",
      "messagesSent": "Messages privés",
      "actionsAgainst": "Modération à leur encontre",
      "actionsTaken": "Modération qu'ils ont exercée",
      "restrictions": "Restrictions actives",
      "consent": "Analyses comportementales",
      "consentGranted": "Accepté",
      "consentDeclined": "Refusé",
      "consentNeverAsked": "Jamais demandé",
      "whereTheyGo": "Où ils passent leur temps",
      "whereTheyGoDescription": "Les mondes que ce compte fréquente le plus, au temps passé plutôt qu'au nombre de visites.",
      "worldFigure": "{{visits}} visites · {{time}}",
      "noWorldsTitle": "Ce compte n'est entré dans aucun monde",
      "noWorldsDescription": "Rien à classer tant que ce n'est pas le cas.",
      "worldChat": "Chat de monde"
    },
    "health": {
      "requests": "Requêtes",
      "requestsOff": "Instrumentation désactivée",
      "inRange": "Sur cette période",
      "serverErrors": "Erreurs serveur",
      "ofRequests": "des requêtes",
      "latency": "5 % de requêtes les plus lentes",
      "median": "médiane {{ms}} ms",
      "rollup": "Dernier cumul",
      "rollupHint": "Tous les chiffres ici datent de là",
      "queues": "Files et ingestion",
      "assetsQueued": "Ressources en attente",
      "assetsRunning": "Ressources en cours",
      "assetsFailed": "Ressources en échec",
      "exportsPending": "Exports en attente",
      "exportsFailed": "Exports en échec",
      "eventsIngested": "Événements ingérés",
      "samplesIngested": "Échantillons spatiaux ingérés",
      "clients": "Ce que rapportent les clients",
      "sessions": "Sessions de monde",
      "clientErrors": "Erreurs client",
      "errorsValue": "{{errors}} ({{fatal}} fatales)",
      "abandonRate": "Partis avant le chargement",
      "fps": "Images par seconde",
      "fpsValue": "{{average}} moy. · {{worst}} pires 5 %",
      "rtt": "Aller-retour (médiane)",
      "liveRooms": "En direct",
      "liveRoomsValue": "{{rooms}} salles · {{people}} personnes",
      "stored": "Stocké",
      "busiestRoutes": "Routes les plus sollicitées",
      "busiestRoutesDescription": "Par nombre de requêtes. Le MODÈLE de route, jamais le chemin résolu — un chemin contient des identifiants, et cette table n'est pas un endroit pour les garder.",
      "cost": "Coût estimé",
      "costDescription": "D'après les prix configurés sur ce déploiement. Absent quand aucun n'est défini : un coût fondé sur un prix inventé est pire qu'aucun coût, parce qu'on planifie dessus.",
      "costStorage": "Stockage média / mois",
      "costDatabase": "Base de données / mois",
      "costRequests": "Requêtes sur la période",
      "routeServerErrors": "{{count}} 5xx ({{percent}} %)",
      "routeClientErrors": "{{count}} 4xx"
    },
    "export": {
      "format": "Format",
      "action": "Exporter",
      "working": "Préparation…",
      "ready": "Votre export a été téléchargé.",
      "failed": "Cet export n'a pas pu être produit. Réessayez, ou réduisez la période."
    },
    "retention": {
      "title": "Restent-ils ?",
      "description": "Chaque ligne regroupe les personnes arrivées le même jour, et combien revenaient encore ensuite. Une courbe de croissance ne dit pas si le seau est percé ; ceci le dit.",
      "cohort": "Arrivés",
      "size": "Personnes",
      "emptyTitle": "Aucune cohorte sur cette période",
      "emptyDescription": "Les cohortes apparaissent quand les comptes ont eu le temps de revenir — élargissez la plage.",
      "day": "J{{n}}"
    }
  },
  "releases": {
    "title": "Versions de l’application",
    "description": "Quelle version chaque plateforme utilise, où en obtenir une plus récente, et où vit son contenu Addressables.",
    "gateTitle": "Contrôle de version",
    "gateDescription": "Chaque client installé pose cette question avant de démarrer. Une version inférieure au minimum est bloquée avec un lien vers la boutique ; une version inférieure à la dernière se voit proposer la mise à jour une fois et peut refuser.",
    "notGated": "Sans contrôle de version",
    "enabled": "Contrôle activé",
    "latestVersion": "Dernière version",
    "latestVersionHint": "La version publiée la plus récente. Toute version antérieure se voit proposer la mise à jour.",
    "minimumVersion": "Version minimale",
    "minimumVersionHint": "La plus ancienne version encore autorisée. Toute version antérieure est bloquée.",
    "versionInvalid": "Utilisez MAJEUR.MINEUR.CORRECTIF, chiffres uniquement — par exemple 1.4.2.",
    "minimumAboveLatest": "Le minimum ne peut pas dépasser la dernière version : cela bloquerait tous les clients, y compris celui que vous êtes sur le point de publier.",
    "storeKind": "Boutique",
    "storeUrl": "Lien de la boutique",
    "storeUrlHint": "Où mène le bouton de mise à jour. Une URL https:// absolue.",
    "releaseNotesUrl": "Lien des notes de version",
    "releaseNotesUrlHint": "Facultatif. Affiché comme « Nouveautés » à côté du bouton de mise à jour.",
    "contentBaseUrl": "URL de base du contenu",
    "contentBaseUrlHint": "Facultatif. Laissez vide pour servir le contenu depuis ce backend. Renseignez-la pour déplacer le contenu vers un CDN sans reconstruire aucune application installée.",
    "webExplainer": "La version web est servie plutôt qu’installée : elle est donc toujours la plus récente et n’est jamais renvoyée vers une boutique. Elle télécharge tout de même son contenu Addressables comme les autres plateformes.",
    "unsavedHint": "Ces modifications ne sont pas actives tant que vous n’avez pas enregistré.",
    "saved": "{{platform}} enregistrée",
    "saveFailed": "Impossible d’enregistrer cette plateforme",
    "platform": {
      "windows": "Windows",
      "macos": "macOS",
      "android": "Android",
      "quest": "Meta Quest",
      "ios": "iOS",
      "webgl": "Web"
    },
    "store": {
      "appStore": "App Store",
      "googlePlay": "Google Play",
      "metaQuest": "Meta Horizon Store",
      "steam": "Steam",
      "microsoftStore": "Microsoft Store",
      "macAppStore": "Mac App Store",
      "direct": "Téléchargement direct",
      "web": "Aucune boutique (web)"
    },
    "contentTitle": "Livraison du contenu",
    "contentDescription": "Envoyez la build Addressables d’une plateforme. Empaquetez-la dans Unity avec VECOS ▸ Addressables ▸ Package Content For Upload, puis déposez le zip ici.",
    "contentPlatform": "Plateforme",
    "contentFile": "Archive de contenu (.zip)",
    "contentUpload": "Publier le contenu",
    "contentUploading": "Publication…",
    "contentUploaded": "{{count}} fichiers publiés ({{size}}) vers {{platform}}",
    "contentUploadFailed": "Impossible de publier le contenu",
    "contentNoFile": "Choisissez d’abord un zip.",
    "contentWrongType": "Ce n’est pas un zip. Empaquetez d’abord la build dans Unity.",
    "contentWarning": "Cela remplace d’un coup tout ce qui est publié pour cette plateforme. Les clients déjà lancés conservent le catalogue qu’ils détiennent jusqu’à leur prochain démarrage.",
    "gatesNothing": "Ne bloque rien",
    "off": "Contrôle désactivé",
    "unsaved": "Non enregistré",
    "webgl": {
      "title": "Client web",
      "description": "La build Unity WebGL que le site sert. L’envoi stocke une build et ne change rien pour les visiteurs — c’est la mise en service qui déplace le site, et servir une build plus ancienne, c’est cela le retour en arrière.",
      "fileHint": "Le dossier écrit par Unity, zippé à la racine de l’archive : Build/, StreamingAssets/ s’il y en a un, et le manifeste build.json.",
      "upload": "Envoyer la build",
      "uploading": "Envoi…",
      "uploadingHint": "Envoi en cours. Une build complète est volumineuse : cela peut prendre plusieurs minutes — laissez cet onglet ouvert.",
      "uploaded_one": "{{version}} stockée — {{count}} fichier, {{size}}. Rien ne la sert encore.",
      "uploaded_many": "{{version}} stockée — {{count}} fichiers, {{size}}. Rien ne la sert encore.",
      "uploaded_other": "{{version}} stockée — {{count}} fichiers, {{size}}. Rien ne la sert encore.",
      "uploadFailed": "Impossible d’envoyer cette build",
      "wrongType": "Ce n’est pas un zip. Zippez le dossier écrit par Unity, avec build.json à la racine de l’archive.",
      "column": {
        "version": "Version",
        "uploaded": "Envoyée le",
        "files": "Fichiers",
        "size": "Taille",
        "servedAt": "Servie le",
        "action": "Servir"
      },
      "live": "En service",
      "noManifest": "Sans build.json",
      "cannotServe": "Impossible à servir",
      "cannotServeWhy": "Pas de build.json : la page ne saurait pas quels fichiers charger. Recréez l’archive depuis public/play-build après npm run unity:sync.",
      "serve": "Servir",
      "serveNamed": "Servir {{version}}",
      "empty": "Aucune build envoyée",
      "emptyDescription": "Rien n’est stocké ici pour l’instant : le site sert donc ce qui a été déposé à la main sur le serveur — ou rien du tout.",
      "retention": "Seules les builds les plus récentes sont conservées : envoyer une nouvelle build retire la plus ancienne qui n’est pas en service. La build en service n’est jamais supprimée.",
      "confirmTitle": "Servir {{version}} ?",
      "confirmBody": "Tout visiteur qui chargera le client web à partir de maintenant recevra {{version}} — {{size}}, envoyée le {{uploaded}}. Les téléchargements déjà commencés se terminent sur la build de départ. Rien n’est supprimé, et vous pouvez servir une autre build à tout moment.",
      "confirmRollback": "{{version}} a été envoyée avant la build actuellement en service : la servir ramène donc le site en arrière. C’est cela, le retour en arrière — il n’y a pas de commande séparée.",
      "confirmNoManifest": "Cette build n’a pas de build.json. La page le lit pour savoir quels noms de fichiers Unity a écrits : la servir laisserait donc aux visiteurs un client qui ne se charge pas.",
      "confirmAction": "Servir cette build",
      "served": "{{version}} est désormais en service",
      "serveFailed": "Impossible de servir cette build",
      "gone": "Cette build n’est plus stockée. Envoyer une nouvelle build retire la plus ancienne qui n’est pas en service.",
      "dropTitle": "Choisissez une archive de build, ou déposez-la ici",
      "dropHint": "Glissez-déposez, ou cliquez pour parcourir",
      "dropReplace": "cliquez pour en choisir une autre",
      "stored": "Builds stockées",
      "serving": {
        "up": "Le site diffuse {{version}}",
        "upDetail": "Les visiteurs de /play reçoivent cette version et elle se charge.",
        "drift": "Version diffusée incohérente avec les enregistrements",
        "driftDetail": "Le lien suivi par le serveur et la version marquée active ne sont pas les mêmes.",
        "down": "Aucun client n’est diffusé",
        "downNothing": "Rien n’a encore été diffusé : /play indique aux visiteurs que ce serveur héberge le site mais pas le client.",
        "downNoManifest": "La version diffusée n’a pas de build.json : /play indique aux visiteurs que ce serveur héberge le site mais pas le client.",
        "fixNothing": "Envoyez une version, puis cliquez sur Diffuser.",
        "fixNoManifest": "Compressez le contenu de public/play-build après avoir lancé",
        "fixDrift": "Rediffusez la version voulue pour régler cela."
      },
      "uploadedNoManifest": "Enregistrée, mais sans build.json elle ne peut pas être diffusée. Lancez npm run unity:sync et compressez le contenu de public/play-build : Build/, StreamingAssets/ et build.json à la racine."
    }
  }
}
